<smart-card [backButton]="true" buttonColor="white" class="get-status-wrapper">
  <h2 [innerHtml]="'ticket.status.title' | translate"></h2>
  <p [innerHtml]="'ticket.status.p__info' | translate"></p>
  <form (ngSubmit)="submit($event)" [formGroup]="form">
    <formly-form [form]="form" [fields]="formFields" [model]="formModel"></formly-form>
    <div class="get-status-button-container d-flex flex-row justify-center items-center">
      <button
        type="submit"
        color="primary"
        style="flex: 1 1 66%; max-width: 66%; box-sizing: border-box"
        mat-raised-button
      >
        <span class="customSendIconRight"></span>
        <span [innerHtml]="'form.submit' | translate"></span>&nbsp;
        <mat-icon class="materialSendIcon">send</mat-icon>
      </button>
    </div>
  </form>
</smart-card>

<spinner-overlay [show]="loading"></spinner-overlay>
